import { useDataChange, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.treatment_id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(null)
    submit({ type: 'close_popover' })
  }
}
